import { pxToRem, responsiveFontSizes } from '../utils';
// ----------------------------------------------------------------------
const FONT_PRIMARY = 'dai-ap-font, sans-serif';
export const Poppins = {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `local('Poppins'), url('/static/fonts/Poppins-Regular.ttf') format('truetype')`
};
export const PoppinsMedium = {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 500,
    src: `local('Poppins'), url('/static/fonts/Poppins-Medium.ttf') format('truetype')`
};
export const PoppinsSemiBold = {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 600,
    src: `local('Poppins'), url('/static/fonts/Poppins-SemiBold.ttf') format('truetype')`
};
export const PoppinsBold = {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 700,
    src: `local('Poppins'), url('/static/fonts/Poppins-Bold.ttf') format('truetype')`
};
export const PoppinsExtraBold = {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 800,
    src: `local('Poppins'), url('/static/fonts/Poppins-ExtraBold.ttf') format('truetype')`
};
export const Typography = {
    fontFamily: FONT_PRIMARY,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    h1: Object.assign({ fontWeight: 500, lineHeight: 80 / 64, fontSize: pxToRem(40) }, responsiveFontSizes({ sm: 52, md: 58, lg: 64 })),
    h2: Object.assign({ fontWeight: 500, lineHeight: 64 / 48, fontSize: pxToRem(32) }, responsiveFontSizes({ sm: 40, md: 44, lg: 48 })),
    h3: Object.assign({ lineHeight: 1.5, fontWeight: 500, fontSize: pxToRem(24) }, responsiveFontSizes({ sm: 26, md: 30, lg: 32 })),
    h4: Object.assign({ lineHeight: 1.5, fontWeight: 500, fontSize: pxToRem(20) }, responsiveFontSizes({ sm: 20, md: 24, lg: 24 })),
    h5: Object.assign({ lineHeight: 1.5, fontWeight: 500, fontSize: pxToRem(18) }, responsiveFontSizes({ sm: 19, md: 20, lg: 20 })),
    h6: Object.assign({ fontWeight: 500, lineHeight: 28 / 18, fontSize: pxToRem(17) }, responsiveFontSizes({ sm: 18, md: 18, lg: 18 })),
    subtitle1: {
        fontSize: pxToRem(16),
        lineHeight: 1.5,
        fontWeight: 500
    },
    subtitle2: {
        fontSize: pxToRem(14),
        lineHeight: 22 / 14,
        fontWeight: 500
    },
    body1: {
        fontSize: pxToRem(16),
        lineHeight: 1.5
    },
    body2: {
        fontSize: pxToRem(14),
        lineHeight: 22 / 14
    },
    caption: {
        fontSize: pxToRem(12),
        lineHeight: 1.5
    },
    overline: {
        fontSize: pxToRem(12),
        lineHeight: 1.5,
        fontWeight: 700,
        letterSpacing: 1.2,
        textTransform: 'uppercase'
    },
    button: {
        fontWeight: 700,
        lineHeight: 24 / 14,
        fontSize: pxToRem(14),
        textTransform: 'capitalize'
    }
};
//# sourceMappingURL=typography.js.map